import { render } from "./JournalLineup.vue?vue&type=template&id=974c1f90&scoped=true"
import script from "./JournalLineup.vue?vue&type=script&lang=js"
export * from "./JournalLineup.vue?vue&type=script&lang=js"

import "./JournalLineup.vue?vue&type=style&index=0&id=974c1f90&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974c1f90"]])

export default __exports__